import React from 'react';
import Flex from '../Flex/Flex';
import Gutter from '../Gutter/Gutter';
import styles from './AvailabilityIndicator.module.scss';
import Div from '../Element/Div/Div';
import { SupportedColor } from '../Element/Element';
import { CreateProps } from '../../types/utils/CreateProps';

type AvailabilityIndicatorProps = CreateProps<
  {
    color: SupportedColor;
  },
  typeof Flex,
  'centeredVertically'
>;

const AvailabilityIndicator: React.FunctionComponent<AvailabilityIndicatorProps> = ({
  color,
  children,
  ...props
}) => {
  return (
    <Flex centeredVertically {...props}>
      <Div
        backgroundColor={color}
        borderRadius={{ size: 'rounded' }}
        className={styles.indicator}
      />
      <Gutter size="xs" />

      {children}
    </Flex>
  );
};

export default AvailabilityIndicator;
